import { LegalDocumentPage } from './legal-document-page';

export const TermsPage = () => <LegalDocumentPage documentKey="terms" />;
